<script>
  import BatchProcessor from '../components/BatchProcessor.svelte';
</script>

<div class="container">
  <div class="batch-page">
    <h1>이미지 배치 처리 페이지</h1>
    <p class="description">이 페이지에서는 다량의 이미지를 멀티스레딩으로 한번에 배경 제거할 수 있습니다. 테스트 모드와 실제 API 모두 사용 가능합니다.</p>
    
    <div class="processor-container">
      <BatchProcessor />
    </div>
  </div>
</div>

<style>
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .batch-page {
    margin-top: 20px;
  }
  
  h1 {
    color: #141414;
    margin-bottom: 10px;
  }

  :global(.dark) h1 {
    color: #f5f5f5;
  }
  
  .description {
    color: #141414;
    margin-bottom: 30px;
  }

  :global(.dark) .description {
    color: #f5f5f5;
  }
  
  .processor-container {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
</style>